import { v4 as uuidv4 } from "uuid";
import { email } from "vee-validate/dist/rules";

export default {
    mixins: [],
    data: () => ({
        currentPackage: ""
    }),
    computed: {
        whatRouteRedirect() {
            return this.$store.getters.getLanguage == "es"
                ? "es.albumes"
                : "albumes";
        },
        // Computado para identificar si la ruta actual es Album
        isAlbumRoute() {
            const routeNameCurrent = this.$route.name;
            return (
                routeNameCurrent == "albumes" ||
                routeNameCurrent == "es.albumes"
            );
        },
    },
    methods: {
        hasDownloadCode(__downloadCode) {
            return Object.values(this.$store.state.albumes).some(
                (element) => element.code == __downloadCode && element.Type == 0
            );
        },
        async downloadCode(__downloadCode) {
            try {
                const __email = this.$store.state.email.toString();
                this.$store.dispatch("setLoading", true);

                if (this.hasDownloadCode(__downloadCode)) {
                    Vue.$toast.open({
                        message: this.$t("Forms.exist_code"),
                        type: "info",
                    });

                    this.$store.dispatch("setLoading", false);

                    if (this.$route.name != "albumes") {
                        this.$router.push({ name: "albumes" });
                    }

                    return;
                }

                // Verificamos si el codigo es valido
                let parameters1 = {
                    question: 0,
                    JoinedCode: __downloadCode,
                };
                const response = await this.$store.dispatch(
                    "isValidCode",
                    parameters1
                );
                

                // Validamos si hay algun error
                if (!response.IsValid) {
                    this.$store.dispatch("setLoading", false);

                    Vue.$toast.open({
                        message: this.$t("messages.invalid_code"),
                        type: "error",
                    });

                    return;
                }

                // Guardamos el codigo de descarga en la DB para obtenerla despues en su sesion
                const codeToSave = {
                    SearchInput: __downloadCode,
                    VisitorEmail: __email,
                    ParkID: null,
                    VisitDate: null,
                    SearchType: 0,
                };
                this.currentPackage = response.ProductName;

                if(email != "" || email != null)
                    this.$store.dispatch("VisitorActivity", codeToSave);

                this.getAlbumsByDownloadCode(__downloadCode);
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                Vue.$toast.open({
                    message: this.$t("Forms.try_catch_api"),
                    type: "error",
                });

                Vue.$toast.open({
                    message: this.$t("messages.album_error_add"),
                    type: "error",
                });

                
            }
        },
        async getAlbumsByDownloadCode(code) {
            try {
                this.$store.dispatch("setLoading", true);
                /* Creating an object with the parameters to send to the API. */
                const parameters = {
                    type: 0,
                    params: { JoinedCode: code },
                };
                /* Calling the API to get the albums by email. */
                const response = await this.$store.dispatch(
                    "getAlbums",
                    parameters
                );
                

                if (!response[0].PhotoExperiences.length) {
                    this.$store.dispatch("setLoading", false);
                    Vue.$toast.open({
                        message: this.$t("Validations.code_dont_have_parks"),
                        type: "error",
                    });
                    this.$store.dispatch("setLoading", false);

                    return;
                }

                /* Calling the method `formatAlbumsByDownloadCode` and passing the response from the API. */
                const data = this.formatAlbumsByDownloadCode(response);

                /* A method that is used to show a loading icon on the screen. */
                this.$store.dispatch("setLoading", false);

                /* Checking if the response from the API has data. If it does, it will redirect the
                user to the `albumes` route. */
                this.$store.dispatch("setModalAddAlbum", false);
                if (this.$route.name == "albumes") {
                    Vue.$toast.open({
                        message: this.$t("messages.album_add_successfully"),
                        type: "success",
                    });

                    return;
                } else {
                    this.$router.push({ name: "albumes" });
                }
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                
            }
        },
        formatAlbumsByDownloadCode(data) {
            data.forEach((item) => {
                if (item.PhotoDetails.Type === 0) {
                    
                    let album = this.albumsByDownloadCode(item);
                    this.$store.dispatch("setAlbum", [album]);
                }
            });

            this.$store.dispatch("setDownloadCodeTab", true);
            this.$store.dispatch("setTypeCodeTab", 0);
        },
        albumsByDownloadCode(data) {
            let album = {};
            const photoDetails = data.PhotoDetails;

            album.uuid = uuidv4();
            album.code = photoDetails.JoinedCode;
            album.park = data.PhotoExperiences;
            // Este nodo solo llegara activado cuando el codigo sea una orden de Postventa
            album.order = photoDetails.Order;
            album.Type = photoDetails.Type;

            album.getCode = { AvailableParks: photoDetails.AvailableParks, PackageName: this.currentPackage };
            album.selectedParks = photoDetails.SelectedParks;

            return album;
        },
    },
};
